import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay, requireAuth } from '@/test/mocks/utils';

import { SelectProfileResponse } from '../types';

import { mockProfileState } from './get-profiles';

export const selectProfile = (
  profile_id: string
): Promise<SelectProfileResponse.Root> => {
  return axios.post(`/user/v1/profile/select`, { profile_id });
};

export const selectProfileMockHandler = http.post(
  `${env.API_URL}/user/v1/profile/select`,
  async ({
    request,
    cookies,
  }): Promise<HttpResponse<SelectProfileResponse.Root>> => {
    await networkDelay();
    const { error } = requireAuth(cookies);
    if (error) {
      return HttpResponse.json(
        {
          message: error,
          status: 'Failure',
        },
        { status: 401 }
      );
    }

    // Parse the request body to get the profile_id
    const body = (await request.json()) as { profile_id: string };

    // Validate that profile_id exists
    if (!body.profile_id) {
      return HttpResponse.json(
        {
          message: 'Profile ID is required',
          status: 'Failure',
        },
        { status: 400 }
      );
    }

    // Update the mock state with the selected profile
    mockProfileState.setSelectedProfile(body.profile_id);

    return HttpResponse.json({
      status: 'Success',
      message: 'Profile selected successfully',
    });
  }
);
